var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-file-input',{attrs:{"dense":"","outlined":"","label":`Upload ${_vm.labelText?_vm.labelText:'Image'}`,"accept":"image/*"},on:{"change":_vm.handleImageUpload},model:{value:(_vm.imageFile),callback:function ($$v) {_vm.imageFile=$$v},expression:"imageFile"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }